import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DescricaoPadrao } from '../models/descricaoPadrao.model';
import { environment } from '../../../src/app/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DescricaoPadraoService {
  private apiUrl = `${environment.advContabilApi}/api/descricaoPadrao`;

  constructor(private http: HttpClient) {}

  getDescricaoPadrao(usuarioId: string): Observable<DescricaoPadrao[]> {
    return this.http.get<DescricaoPadrao[]>(`${this.apiUrl}/listar?usuarioId=${usuarioId}`);
  }

  addDescricaoPadrao(descricaoPadrao: DescricaoPadrao): Observable<DescricaoPadrao> {
    return this.http.post<DescricaoPadrao>(`${this.apiUrl}/inserir`, descricaoPadrao);
  }

  updateDescricaoPadrao(descricaoPadrao: DescricaoPadrao): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/atualizar/${descricaoPadrao.id}`, descricaoPadrao);
  }

  deleteDescricaoPadrao(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/deletar/${id}`);
  }

  getDescricaoPadraoById(id: number): Observable<DescricaoPadrao> {
    return this.http.get<DescricaoPadrao>(`${this.apiUrl}/obter/${id}`);
  }
}
